export default "__VITE_ASSET__Bwm9xUZo__"